import React from "react";

const IconKiosk = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 15.144 18.797">
      <g
        id="Group_2676"
        dataname="Group 2676"
        transform="translate(575.209 -269.322)"
      >
        <g id="Group_414" dataname="Group 414">
          <g id="Group_414-2" dataname="Group 414-2">
            <path
              id="Rectangle_130"
              dataname="Rectangle 130"
              d="M-570.581,287.359v-8.451h5.252v8.451"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_502"
              dataname="Path 502"
              d="M-563.37,278.909v7.626a1.084,1.084,0,0,1-1.084,1.084h-8.423"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_503"
              dataname="Path 503"
              d="M-560.586,271.052l-1.434,7.038a1.026,1.026,0,0,1-1.005.819h-10.659a1.025,1.025,0,0,1-1.025-1.025,1.088,1.088,0,0,1,.02-.205l1.434-7.036a1.025,1.025,0,0,1,1-.821h10.66a1.026,1.026,0,0,1,1.026,1.026A1,1,0,0,1-560.586,271.052Z"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </g>
        </g>
        <line
          id="Line_206"
          dataname="Line 206"
          x1="1.953"
          y2="2.343"
          transform="translate(-569.767 272.895)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <line
          id="Line_207"
          dataname="Line 207"
          x1="2.307"
          y2="2.769"
          transform="translate(-567.814 273.067)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export default IconKiosk;
